// src/components/FeatherIcon.js
import React, { useEffect, useRef } from 'react';
import feather from 'feather-icons';

const FeatherIcon = ({ icon, ...props }) => {
  const iconRef = useRef(null);

  useEffect(() => {
    if (iconRef.current) {
      iconRef.current.innerHTML = feather.icons[icon].toSvg(props);
    }
  }, [icon, props]);

  return <span ref={iconRef} />;
};

export default FeatherIcon;
